import { AbstractFreewheelRequestFactory } from 'tag/ts/tag/ads/freewheel/factories/AbstractFreewheelRequestFactory';
import { FreewheelImaRequest } from 'tag/ts/tag/ads/freewheel/requests/FreewheelImaRequest';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';

/**
 * @copyright © Paramount Streaming
 * @author  Zeeshan Ahmad
 * @description Used to create Freewheel IMA request
 */
export class FreewheelImaRequestFactory extends AbstractFreewheelRequestFactory {

	constructor( argument: ITagAbstractClassArgument ) {
		super(
			{
				...argument,
				name: 'FreewheelImaRequestFactory'
			}
		);
	}

	/**
	 * @description Returns a FreewheelImaRequest
	 * @return {FreewheelImaRequest}
	 */
	createRequest(): FreewheelImaRequest {
		const request = new FreewheelImaRequest( { tag: this.tag } );
		this?.logger?.log( 'createRequest', 'returning FreewheelImaRequest:', request );
		return request;
	}
}